import { render, staticRenderFns } from "./StarEmpty.vue?vue&type=template&id=151e67de&scoped=true&"
var script = {}
import style0 from "./StarEmpty.vue?vue&type=style&index=0&id=151e67de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151e67de",
  null
  
)

export default component.exports